/**
 * Mecanismo de demonstração para capturas e testes atrás do login (ADR-009).
 *
 * `?demo=<papel>` (owner, partner, traffic, creative, support, expert, tech) abre uma sessão sem
 * senha com a pessoa de demonstração do papel. **Só no dev server** (`import.meta.env.DEV`): no
 * build de produção o parâmetro é ignorado. Para o build de produção (e2e), use o `storageState`
 * do Playwright criado por `apps/web/e2e/auth.setup.ts`.
 *
 *   node scripts/shot.mjs --port 5401 --route /automacoes --query "demo=support&hora=14:32"
 */
import type { Role } from '@rota/contracts';

const ROLES: readonly Role[] = ['owner', 'partner', 'traffic', 'creative', 'support', 'expert', 'tech'];

export const DEMO_PARAM = 'demo';

export function demoAllowed(): boolean {
  return import.meta.env.DEV === true;
}

/**
 * `?demo=login`: um dono com senha aleatória (nunca mostrada) e nenhuma sessão, só para capturar e
 * testar a tela `/entrar` no dev server.
 */
export function demoLoginFromUrl(
  search: string = typeof location === 'undefined' ? '' : location.search,
): boolean {
  return demoAllowed() && new URLSearchParams(search).get(DEMO_PARAM) === 'login';
}

/** Papel pedido por `?demo=` (ou `null`). Fora do dev server sempre `null`. */
export function demoRoleFromUrl(
  search: string = typeof location === 'undefined' ? '' : location.search,
): Role | null {
  if (!demoAllowed()) return null;
  const v = new URLSearchParams(search).get(DEMO_PARAM);
  return v && (ROLES as readonly string[]).includes(v) ? (v as Role) : null;
}
